import React, { useState, useEffect } from 'react';
// import DatePicker from 'react-datepicker';
import { Button, Form, Modal, Stack } from 'react-bootstrap';
import { GoSearch } from 'react-icons/go';
import { MdErrorOutline } from 'react-icons/md'
import { facmanGetUnassignedMeters, facmanGetAssignedMeters, facilityManagaerAddNewMeter, facilityManagaerUpdateMeter, PUT_CH_ADD_NEW_METER_SUCCESS, PUT_CH_UPDATE_METER_SUCCESS, commercialHeadGetAllFacilitiesForNav, commercialHeadGetCompleteContractsForDropdown } from '../../Redux/Actions/Actions';
import { useSelector, useDispatch } from 'react-redux';
import NavBarTop from "../Reusable_Components/NavBarTop";
import LeftNavBar from "../Reusable_Components/LeftNavBar";
import 'react-datepicker/dist/react-datepicker.css';
import { set } from 'date-fns';
import { Alert } from 'react-bootstrap';
import Loader from "../Reusable_Components/loader";
import AlertPopUp from '../Reusable_Components/Alert';
import Pagination from '../Reusable_Components/Pagination';
import { RECORDS_PER_PAGE, RECORDS_PER_PAGE_METER_MASTER } from '../../Config';
import { timeElapsed, validateValue, formatNumericInput, handleKeyDownForMeterReadings, formatDateBasedOnValue } from "../Reusable_Components/ReusableFunctions";
import { formatDateView } from "../Reusable_Components/ReusableFunctions";
import Footer from "../Login/Footer";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import axios from 'axios';
import { base_url } from '../../utilities';
import { FaSort } from 'react-icons/fa';
import { IoMdAdd } from "react-icons/io";
import { useLocation } from 'react-router-dom';
import SearchableDropdown from '../Reusable_Components/SearchableDropdown';


const MeterMaster = () => {
    const location = useLocation()
    const { props } = location.state || {};
    const [notificationLoader, setNotificationLoader] = useState(false);
    const [showUnassignConfirm, setShowUnassignConfirm] = useState(false);

    useEffect(() => {
        const details = {
            meter_id: props?.entity_details?.meter_id,
            facility_id: props?.entity_details?.facility_id,
        }
        // console.log("details", details)
        if (details?.meter_id) {
            setNotificationLoader(true);
            fetchMeterbyId(details.meter_id)
        } else if (details?.facility_id) {
            setNotificationLoader(true);
            dispatch(facmanGetAssignedMeters({
                search_text: '',
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: 1,
                filter_condition: {
                    facility_id: details.facility_id
                }
            }))
        }
    }, [props])


    const fetchMeterbyId = (meter_id) => {
        axios.get(base_url + `facilities/meters`, {
            params: {
                filter_condition: JSON.stringify({
                    "meter_id": meter_id,

                })
            }
        })
            .then(res => {
                // console.log("Meter data fetched successfully:", res.data);
                const responseData = res.data.data[0];
                handleAddNewMeterShowEdit(responseData);
                setNotificationLoader(false);

            })
            .catch(error => {
                console.error("Error fetching meter data:", error);

            });

    }

    const [searchText, setSearchText] = useState('');
    const [selectMeter, setSelectMeter] = useState('all');
    const [meterType, setMeterType] = useState('assigned');

    const dispatch = useDispatch();
    const allUnassignedMeters = useSelector(state => state.allUnassignedMeters?.data);
    const assignedMeters = useSelector(state => state.assignedMeters?.data);
    const error = useSelector(state => state.error);
    const facilitiesList = useSelector(state => state.facilitiesList)
    const isAddedMeter = useSelector(state => state.addedMeter);
    const addMeterError = useSelector(state => state.addMeterError)
    const updateMeterSuccess = useSelector(state => state.updateMeterSuccess)
    const contractApiLoader = useSelector(state => state.contractApiLoader)
    const allContracts = useSelector((state) => state.contractsForDropdown);
    const [selectedContract, setSelectedContract] = useState('');



    const [modalMeters, setModalMeters] = useState([])
    const [filteredMeters, setFilteredMeters] = useState(null);

    const [showAddNewMeterPopUP, setShowAddNewMeterPopUp] = useState(false);
    const [meterSuccessPopUp, setMeterSuccessPopUp] = useState(false);
    const [meterErroePopUp, setMeterErrorPopUp] = useState(false);
    const [lenghtError, setLengthError] = useState(false)
    const [meterNumberError, setMeterNumberError] = useState(false);
    const [uniqueMeterNumberError, setUniqueMeterNumberError] = useState(false);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [modalMeterType, setModalMeterType] = useState("electricity");
    const [modelMeterNumber, setModalMeterNumber] = useState('');
    const [intialEBReading, setIntialEBReading] = useState('');
    const [intialDGReading, setIntialDGReading] = useState('');
    const [intialReading, setIntialReading] = useState('');
    const [assignedNameSort, setAssignedNameSort] = useState(false);
    const [assignedMeterNumberSort, setAssignedMeterNumberSort] = useState(false);
    const [unassignedMeterNumberSort, setUnassignedMeterNumberSort] = useState(false);
    const [companyNameSort, setCompanyNameSort] = useState(false);
    const [contractNameSort, setContractNameSort] = useState(false);
    const [assignedDateSort, setAssignedDateSort] = useState(null);
    const [initialReadingSort, setInitialReadingSort] = useState(null);
    const [unassignedDateSort, setUnassignedDateSort] = useState(null);
    const [finalReadingSort, setFinalReadingSort] = useState(null);
    const [createdAtSort, setCreatedAtSort] = useState(null);
    const [updatedAtSort, setUpdatedAtSort] = useState(null);
    const [statusAtSort, setStatusAtSort] = useState(null);

    const [selectedDate, setSelectedDate] = useState(null);
    const [errorValue, setErrorValue] = useState(null);
    const [loading, setLoading] = useState(false);
    //for alert pop up
    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])
    const [alertAction, setAlertAction] = useState([])
    const [meterName, setMeterName] = useState('')

    const [finalMeterReading, setFinalMeterReading] = useState(null)
    const [finalDgMeterReadings, setFinalDgMeterReadings] = useState(null)

    const [showCloseConfirmationModal, setShowCloseConfirmationModal] = useState(false)
    const handleCloseConfirmation = () => setShowCloseConfirmationModal(false);
    const handleProceed = () => {
        handleCloseConfirmation();
        handleAddNewMeterClose();
        setSelectedMeterToEdit(null)
        setEditedMeterStatus(null)
        setIsEditClicked(false)
        setFinalMeterReading(null)
        setFinalDgMeterReadings(null)
        setSelectedContract('')
        setMeterName('')
        setSelectedMeterToEdit(null)
    };

    const handleContractSelect = (e) => {
        setSelectedContract(e.target.value);
    }

    useEffect(() => {
        dispatch(facmanGetUnassignedMeters(
            {
                search_text: searchText,
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: 1,
                filter_condition: {
                    facility_id: localStorage.getItem("selected_facility_id"),
                    is_in_use: 0,
                    // is_working: 1
                }
            }
        ));

        dispatch(facmanGetAssignedMeters({
            search_text: searchText,
            items_per_page: RECORDS_PER_PAGE_METER_MASTER,
            page_number: 1,
            filter_condition: {
                facility_id: localStorage.getItem("selected_facility_id")
            }
        }
        ))
        dispatch(commercialHeadGetAllFacilitiesForNav())
        const facilityId = localStorage.getItem("selected_facility_id")
        dispatch(commercialHeadGetCompleteContractsForDropdown(facilityId))
    }, [dispatch]);

    const totalRecordsAssigned = useSelector(state => state.assignedMeters?.info?.total_no_of_records);
    const totalRecordsUnassigned = useSelector(state => state.allUnassignedMeters?.info?.total_no_of_records);

    const currentPaginationPageAssigned = useSelector(state => state.assignedMeters?.info?.page_number);
    const currentPaginationPageUnassigned = useSelector(state => state.allUnassignedMeters?.info?.page_number);

    useEffect(() => {
        if (meterType === 'assigned') {
            setFilteredMeters(assignedMeters);

        } else {
            setFilteredMeters(allUnassignedMeters);
        }
        setNotificationLoader(false);
    }, [assignedMeters, allUnassignedMeters, meterType]);

    useEffect(() => {
        setErrorValue(error?.response?.data.message);
        if (error?.response?.data.message || error?.data?.data[1]?.message) {
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error')
            setAlertValue(error?.data?.data[1] ? error?.data?.data[1].message : error?.response?.data.message)
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false)
                    dispatch({
                        type: PUT_CH_UPDATE_METER_SUCCESS,
                        payload: null
                    })
                }
            }])
        }
        setLoading(false);
    }, [error])

    useEffect(() => {
        setLoading(true);
    }, []);

    useEffect(() => {
        if (filteredMeters) {
            setLoading(false);
        }
    }, [filteredMeters])

    useEffect(() => {
        if (updateMeterSuccess === "success") {
            setShowAddNewMeterPopUp(false);
            setAlertShow(true)
            setAlertType('success')
            setAlertMessage('Success')
            setAlertValue(<>
                <p>Meter <b>{modelMeterNumber}</b> Updated Successfully</p>
            </>)
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false)
                    setSelectedMeterToEdit(null)
                    setEditedMeterStatus(null)
                    setIsEditClicked(false)
                    handleAddNewMeterClose()
                    dispatch({
                        type: PUT_CH_UPDATE_METER_SUCCESS,
                        payload: null
                    })
                    handleApply()
                }
            }])
        }
    }, [updateMeterSuccess])


    useEffect(() => {
        if (isAddedMeter === "success") {
            setShowAddNewMeterPopUp(false);
            setMeterSuccessPopUp(true)
        }
        setLoading(false);
    }, [isAddedMeter])

    useEffect(() => {
        if (modalMeterType === "electricity") {
            setIntialReading('')
        } else if (modalMeterType === 'water') {
            setIntialEBReading('')
            setIntialDGReading('')
        }
    }, [modalMeterType])

    useEffect(() => {
        if (addMeterError) {
            setMeterErrorPopUp(true)
        }
        setLoading(false);

    }, [addMeterError])



    function formatToIndianRupee(number) {
        if (number) {

            const parts = number?.toString().split(".");
            const numStr = parts[0];
            const decimalPart = parts.length > 1 ? "." + parts[1] : "";

            if (numStr?.length <= 3) return numStr + decimalPart;
            let lastThree = numStr.substring(numStr.length - 3);
            const otherNumbers = numStr.substring(0, numStr.length - 3);
            if (otherNumbers !== '') {
                lastThree = ',' + lastThree;
            }
            const output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + decimalPart;
            return output;
        }
        return number
    }

    const onChangeMeterType = (type) => {
        setMeterType(type);

    };
    const handleSearchSubmit = (searchValue) => {
        if (validateValue(searchValue)) {
            setSearchText(searchValue);
        }
    };

    const handleDateChange = (e) => {
        const value = e.format("YYYY-MM-DD");
        setSelectedDate(value);
    };

    const onChangeMeter = (value) => {
        setSelectMeter(value);

    };

    const sortAssignedName = () => {
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const nameA = a.assigned_name ? a.assigned_name.toLowerCase() : '';
            const nameB = b.assigned_name ? b.assigned_name.toLowerCase() : '';
            return nameA.localeCompare(nameB);
        });
        if (assignedNameSort) {
            setAssignedNameSort(!assignedNameSort);
            sortedMeters.reverse();
        } else {
            setAssignedNameSort(!assignedNameSort);
        }
        setFilteredMeters(sortedMeters);
    };

    const sortAssignedMeterNumber = () => {
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const meterA = a.meter_number ? a.meter_number.toLowerCase() : '';
            const meterB = b.meter_number ? b.meter_number.toLowerCase() : '';
            return meterA.localeCompare(meterB);
        });
        if (assignedMeterNumberSort) {
            setAssignedMeterNumberSort(!assignedMeterNumberSort);
            sortedMeters.reverse();
        } else {
            setAssignedMeterNumberSort(!assignedMeterNumberSort);
        }
        setFilteredMeters(sortedMeters);
    };

    const sortUnassignedMeterNumber = () => {
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const meterA = a.meter_number ? a.meter_number.toLowerCase() : '';
            const meterB = b.meter_number ? b.meter_number.toLowerCase() : '';
            return meterA.localeCompare(meterB);
        });
        if (unassignedMeterNumberSort) {
            setUnassignedMeterNumberSort(!unassignedMeterNumberSort);
            sortedMeters.reverse();
        } else {
            setUnassignedMeterNumberSort(!unassignedMeterNumberSort);
        }
        setFilteredMeters(sortedMeters);
    };

    const sortCompanyName = () => {
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const companyA = a.company_name ? a.company_name.toLowerCase() : '';
            const companyB = b.company_name ? b.company_name.toLowerCase() : '';
            return companyA.localeCompare(companyB);
        }
        );
        if (companyNameSort) {
            setCompanyNameSort(!companyNameSort);
            sortedMeters.reverse();
        }
        else {
            setCompanyNameSort(!companyNameSort);
        }
        setFilteredMeters(sortedMeters);
    };
    const sortContractName = () => {
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const contractA = a.contract_name ? a.contract_name.toLowerCase() : '';
            const contractB = b.contract_name ? b.contract_name.toLowerCase() : '';
            return contractA.localeCompare(contractB);
        });

        if (contractNameSort) {
            setContractNameSort(!contractNameSort);
            sortedMeters.reverse();
        } else {
            setContractNameSort(!contractNameSort);
        }

        setFilteredMeters(sortedMeters);
    };
    const sortAssignedDate = () => {
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const dateA = a.assigned_date ? a.assigned_date.toLowerCase() : '';
            const dateB = b.assigned_date ? b.assigned_date.toLowerCase() : '';
            return dateA.localeCompare(dateB);
        }
        );
        if (assignedDateSort) {
            setAssignedDateSort(!assignedDateSort);
            sortedMeters.reverse();
        }
        else {
            setAssignedDateSort(!assignedDateSort);
        }
        setFilteredMeters(sortedMeters);
    };
    const sortInitialReading = () => {
        if (!Array.isArray(filteredMeters)) {
            console.error('filteredMeters is not an array');
            return;
        }
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const readingA = a.initial_reading !== null ? parseInt(a.initial_reading, 10) : Number.NEGATIVE_INFINITY;
            const readingB = b.initial_reading !== null ? parseInt(b.initial_reading, 10) : Number.NEGATIVE_INFINITY;
            return readingA - readingB;
        });
        if (initialReadingSort) {
            setInitialReadingSort(!initialReadingSort);
            sortedMeters.reverse();
        } else {
            setInitialReadingSort(!initialReadingSort);
        }
        setFilteredMeters(sortedMeters);
    };
    const sortUnassignedDate = () => {
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const dateA = a.unassigned_date ? a.unassigned_date.toLowerCase() : '';
            const dateB = b.unassigned_date ? b.unassigned_date.toLowerCase() : '';
            return dateA.localeCompare(dateB);
        }
        );
        if (unassignedDateSort) {
            setUnassignedDateSort(!unassignedDateSort);
            sortedMeters.reverse();
        }
        else {
            setUnassignedDateSort(!unassignedDateSort);
        }
        setFilteredMeters(sortedMeters);
    };
    const sortFinalReading = () => {
        if (!Array.isArray(filteredMeters)) {
            console.error('filteredMeters is not an array');
            return;
        }
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const readingA = a.final_reading !== null ? parseInt(a.final_reading, 10) : Number.NEGATIVE_INFINITY;
            const readingB = b.final_reading !== null ? parseInt(b.final_reading, 10) : Number.NEGATIVE_INFINITY;
            return readingA - readingB;
        });
        if (finalReadingSort) {
            setFinalReadingSort(!finalReadingSort);
            sortedMeters.reverse();
        } else {
            setFinalReadingSort(!finalReadingSort);
        }
        setFilteredMeters(sortedMeters);
    };

    const sortCreatedAt = () => {
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const dateA = a.created_at ? a.created_at.toLowerCase() : '';
            const dateB = b.created_at ? b.created_at.toLowerCase() : '';
            return dateA.localeCompare(dateB);
        }
        );
        if (createdAtSort) {
            setCreatedAtSort(!createdAtSort);
            sortedMeters.reverse();
        }
        else {
            setCreatedAtSort(!createdAtSort);
        }
        setFilteredMeters(sortedMeters);
    };

    const sortUpdatedAt = () => {
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const dateA = a.updated_at ? a.updated_at.toLowerCase() : '';
            const dateB = b.updated_at ? b.updated_at.toLowerCase() : '';
            return dateA.localeCompare(dateB);
        }
        );
        if (updatedAtSort) {
            setUpdatedAtSort(!updatedAtSort);
            sortedMeters.reverse();
        }
        else {
            setUpdatedAtSort(!updatedAtSort);
        }
        setFilteredMeters(sortedMeters);
    };

    const sortStatus = () => {
        let sortedMeters = [...filteredMeters];
        sortedMeters.sort((a, b) => {
            const statusA = a.is_working ? a.is_working.toString() : '';
            const statusB = b.is_working ? b.is_working.toString() : '';
            return statusA.localeCompare(statusB);
        });
        if (statusAtSort) {
            setStatusAtSort(!statusAtSort);
            sortedMeters.reverse();
        } else {
            setStatusAtSort(!statusAtSort);
        }
        setFilteredMeters(sortedMeters);
    };


    const handleClear = () => {
        setLoading(true)
        setSelectedDate(null);
        setSearchText('');
        setSelectMeter('all');
        // setFilteredMeters(meterType === 'assigned' ? assignedMeters : allUnassignedMeters);

        dispatch(facmanGetUnassignedMeters({
            items_per_page: RECORDS_PER_PAGE_METER_MASTER,
            page_number: 1,
            filter_condition: {
                facility_id: localStorage.getItem("selected_facility_id"),
                is_in_use: 0,
                // is_working: 1
            }
        }
        ));
        dispatch(facmanGetAssignedMeters(
            {
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: 1,
                filter_condition: {
                    facility_id: localStorage.getItem("selected_facility_id"),
                }
            }
        ))
    }


    const modelMeterTypeSelect = (e) => {
        setModalMeterType(e.target.value);
        if (modalMeterType === 'electricity' || 'water') {
            setModalMeterNumber('');
        }
    };

    const handleIntialEBReading = (e) => {
        const input = e.target.value;
        const formattedInput = formatNumericInput(input, 3);
        setIntialEBReading(formattedInput);
    };

    const handleIntialDGReading = (e) => {
        const input = e.target.value;
        const formattedInput = formatNumericInput(input, 3);
        setIntialDGReading(formattedInput);
    };

    const handleIntialReading = (e) => {
        const input = e.target.value;
        const formattedInput = formatNumericInput(input, 3);
        setIntialReading(formattedInput);
    };

    const handleModalMeterNumber = (e) => {
        const inputValue = e.target.value;
        const regex = /^[A-Za-z0-9-/_]+$/;
        if (inputValue.length < 3 || inputValue.length > 200) {
            setLengthError(true)
        }
        else {
            setLengthError(false)
        }
        if (regex.test(inputValue) || inputValue === '') {
            setModalMeterNumber(inputValue);
            if (isMeterNumberUnique(inputValue)) {
                setUniqueMeterNumberError(false);

            } else {
                setUniqueMeterNumberError(true);
            }
            setMeterNumberError(false);
        } else {
            setMeterNumberError(true);
        }
    };


    const handleAddNewMeterShow = () => {
        setShowAddNewMeterPopUp(true);

        dispatch({
            type: PUT_CH_ADD_NEW_METER_SUCCESS,
            payload: null
        })
    }

    const [selectedMeterToEdit, setSelectedMeterToEdit] = useState(null);
    const [editedMeterStatus, setEditedMeterStatus] = useState(null);
    const [isEditClicked, setIsEditClicked] = useState(false);

    const [contractsWithSpecificService, setContractsWithSpecificService] = useState([])

    const handleAddNewMeterShowEdit = (item) => {
        // console.log("came to edit unassigned", item)
        dispatch({
            type: PUT_CH_ADD_NEW_METER_SUCCESS,
            payload: null
        })
        // ===== getting contracts for specific meter type =====
        axios.get(base_url + `customers/contracts_new`, {
            params: {
                request_type: "dropdown",
                filter_condition: JSON.stringify({
                    "facility_id": localStorage.getItem("selected_facility_id"),
                    "service_code": item.meter_type,
                })
            }
        })
            .then(response => {
                // console.log("response-specific meter type", response.data.data)
                setContractsWithSpecificService(response.data.data)
            }
            ).catch(error => {
                console.error("Error fetching contract meter reference:", error);
            }
            )
        // ========================================================
        setShowAddNewMeterPopUp(true);
        setSelectedMeterToEdit(item);
        // console.log(item)
        setModalMeterType(item.meter_type);
        setModalMeterNumber(item.meter_number);
        setEditedMeterStatus(item.is_working);
        if (item.meter_type === 'electricity') {
            setIntialEBReading(item.initial_reading);
            setIntialDGReading(item.initial_dg_reading);
        }
        else {
            setIntialReading(item.initial_reading);
        }



    }

    const handleEditClick = () => {
        setIsEditClicked(true);
    }

    const handleUpdateMeter = () => {
        const data = {
            "meter_id": selectedMeterToEdit.meter_id,
            "facility_id": localStorage.getItem("selected_facility_id"),
            "meter_number": modelMeterNumber,
            "meter_type": modalMeterType,
            "is_working": editedMeterStatus,
            "initial_reading": intialReading || intialEBReading,
            "initial_dg_reading": intialDGReading || null
        }
        dispatch(facilityManagaerUpdateMeter(data))
        // setLoading(true);
    }

    const handleAddNewMeterClose = () => {
        setShowAddNewMeterPopUp(false)
        setLengthError(false)
        setMeterNumberError(false)
        setUniqueMeterNumberError(false)
        setModalMeterType('electricity')
        setModalMeterNumber('')
        setIntialDGReading('')
        setIntialEBReading('')
        setIntialReading('')
        // handleApply()

    };



    useEffect(() => {
        setModalMeters(assignedMeters)
        const requiredFieldsFilled = modalMeterType !== '' || modelMeterNumber !== '' ||
            intialEBReading !== "" || intialDGReading !== "" || intialReading !== ""
        setSaveDisabled(!requiredFieldsFilled);
    }, [])



    const confirmSaveNewMeter = () => {
        setAlertShow(true)
        setAlertType('question')
        setAlertMessage('Confirmation')
        setAlertValue(`Are you sure you want to add the new meter ${modelMeterNumber}?`)
        setAlertButtons([
            {
                name: 'Cancel', action: () => { setAlertShow(false); }
            },
            {
                name: 'Confirm', action: () => { handleNewMetersave(); setAlertShow(false); }
            }
        ])
    }

    const handleNewMetersave = () => {
        const data = {
            "facility_id": localStorage.getItem("selected_facility_id"),
            "meter_number": modelMeterNumber,
            "meter_type": modalMeterType,
            "initial_reading": intialReading || intialEBReading,
            "initial_dg_reading": intialDGReading || null
        }
        dispatch(facilityManagaerAddNewMeter(data))
        setLoading(true);
        setSelectedMeterToEdit(null)
    }

    const isMeterNumberUnique = (meter_number) => {
        return !modalMeters?.some(meters => meters?.meter_number?.toLowerCase() === meter_number?.toLowerCase());
    }

    function formatDateToYYYYMMDD(dateTime) {
        const date = new Date(dateTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based in JavaScript
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const handledPaginationNextClicked = () => {
        setLoading(true)
        let filterValue = {
            facility_id: localStorage.getItem("selected_facility_id")
        }

        if (selectMeter !== 'all') {
            filterValue['meter_type'] = selectMeter
        }
        if (meterType === 'assigned') {
            if (selectedDate) {
                filterValue['assigned_date'] = formatDateToYYYYMMDD(selectedDate)
            }
            dispatch(facmanGetAssignedMeters(
                {
                    search_text: searchText,
                    items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                    page_number: currentPaginationPageAssigned + 1,
                    filter_condition: filterValue
                }
            ))
        }
        else {
            if (selectedDate) {
                filterValue['unassigned_date'] = formatDateToYYYYMMDD(selectedDate)
            }
            filterValue['is_in_use'] = 0;
            // filterValue['is_working'] = 1;
            dispatch(facmanGetUnassignedMeters({
                search_text: searchText,
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: currentPaginationPageUnassigned + 1,
                filter_condition: filterValue
            }
            ));

        }

    }

    const handledPaginationPrevClicked = () => {
        setLoading(true)
        let filterValue = {
            facility_id: localStorage.getItem("selected_facility_id")
        }

        if (selectMeter !== 'all') {
            filterValue['meter_type'] = selectMeter
        }
        if (meterType === 'assigned') {
            if (selectedDate) {
                filterValue['assigned_date'] = formatDateToYYYYMMDD(selectedDate)
            }
            dispatch(facmanGetAssignedMeters(
                {
                    search_text: searchText,
                    items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                    page_number: currentPaginationPageAssigned - 1,
                    filter_condition: filterValue
                }
            ))
        }
        else {
            if (selectedDate) {
                filterValue['unassigned_date'] = formatDateToYYYYMMDD(selectedDate)
            }
            filterValue['is_in_use'] = 0;
            // filterValue['is_working'] = 1;
            dispatch(facmanGetUnassignedMeters({
                search_text: searchText,
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: currentPaginationPageUnassigned - 1,
                filter_condition: filterValue
            }
            ));
        }
    }

    const handleApply = () => {
        setLoading(true)
        localStorage.setItem("selected_facility_name", selectedFacilityName);
        localStorage.setItem("selected_city_name", selectedCityName);
        localStorage.setItem("selected_facility_id", selectedFacilityId);

        let filterValueAssignes = {
            facility_id: selectedFacilityId
        }
        let filterValueUnassigned = {
            facility_id: selectedFacilityId
        }
        if (selectMeter !== 'all') {
            filterValueAssignes['meter_type'] = selectMeter;
            filterValueUnassigned['meter_type'] = selectMeter;
        }
        if (selectedDate) {
            filterValueAssignes['assigned_date'] = formatDateToYYYYMMDD(selectedDate);
            filterValueUnassigned['unassigned_date'] = formatDateToYYYYMMDD(selectedDate);
        }

        dispatch(facmanGetAssignedMeters(
            {
                search_text: searchText,
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: 1,
                filter_condition: filterValueAssignes
            }
        ))

        filterValueUnassigned['is_in_use'] = 0;
        // filterValueUnassigned['is_working'] = 1;
        dispatch(facmanGetUnassignedMeters({
            search_text: searchText,
            items_per_page: RECORDS_PER_PAGE_METER_MASTER,
            page_number: 1,
            filter_condition: filterValueUnassigned
        }
        ))

        setFinalMeterReading(null)
        setFinalDgMeterReadings(null)
        setSelectedContract('')
        setMeterName('')

    }

    const confirmAssignContract = () => {
        const contractObj = contractsWithSpecificService.find(
            (contract) => contract.contract_id === selectedContract
        );
        const contractName = contractObj ? contractObj.contract_name : selectedContract;
        setAlertShow(true)
        setAlertType('question')
        setAlertMessage('Confirmation')
        setAlertValue(`Are you sure you want to assign the  ${modelMeterNumber} to contract ${contractName} with ${meterName}?`)
        setAlertButtons([
            {
                name: 'Cancel', action: () => { setAlertShow(false); }
            },
            {
                name: 'Confirm', action: () => { handleAssignContract(); setAlertShow(false); }
            }
        ])
    }

    const handleAssignContract = () => {
        setLoading(true)
        const body = {
            "meter_id": selectedMeterToEdit?.meter_id,
            "contract_id": selectedContract,
            "assigned_name": meterName,
            "initial_reading": intialReading || intialEBReading,
            "initial_dg_reading": intialDGReading || null,
        }
        // console.log("body", body)
        axios.post(base_url + `customers/contracts/contractMeterRef`, body)
            .then(response => {
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue(<>
                    <p>Meter <b>{modelMeterNumber}</b> Assigned Successfully</p>
                </>)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        handleAddNewMeterClose()
                        handleApply()
                    }
                }])
                setLoading(false)
            })
            .catch(error => {
                console.error("Error assigning contract:", error);
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setLoading(false)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        handleAddNewMeterClose()
                        handleApply()
                    }
                }])
            })

    }

    const handleUnassignContract = () => {
        setLoading(true)
        axios.delete(base_url + `customers/contracts/contractMeterRef`,
            {
                params: {
                    "meter_id": selectedMeterToEdit?.meter_id,
                    "contract_id": selectedMeterToEdit?.contract_id,
                    "final_reading": finalMeterReading,
                    "final_dg_reading": finalDgMeterReadings,
                    "unassigned_date": new Date().toLocaleDateString(),
                    "unassigned_time": new Date().toLocaleTimeString(),
                    "assigned_name": selectedMeterToEdit?.assigned_name,
                    "meter_number": selectedMeterToEdit?.meter_number,
                    "meter_type": selectedMeterToEdit?.meter_type,
                }
            }

        )
            .then(response => {
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue(<>
                    <p>Meter <b>{selectedMeterToEdit?.meter_number}</b> Unassigned Successfully</p>
                </>)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        handleAddNewMeterClose()
                        handleApply()

                    }
                }])
            }
            )
            .catch(error => {
                console.error("Error unassigning contract:", error);
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        handleAddNewMeterClose()
                        handleApply()
                    }
                }])
            }
            )
            .finally(() => {
                setLoading(false)
            })

    }

    // ======================================= city-facility filter setup=================

    useEffect(() => {
        dispatch(commercialHeadGetAllFacilitiesForNav())
    }, [dispatch]);

    const facilitiesListForNav = useSelector(state => state.facilitiesListForNav);
    const [facilityList, setFacilityList] = useState([]);

    useEffect(() => {
        if (facilitiesListForNav) {
            const options = facilitiesListForNav?.map((facility) => `${facility.city}, ${facility.name}`);
            setFacilityList(options);
        }
    }, [facilitiesListForNav]);

    const [selectedFacility, setSelectedFacility] = useState(`${localStorage.getItem("selected_city_name")}, ${localStorage.getItem("selected_facility_name")}`);
    const [selectedFacilityId, setSelectedFacilityId] = useState(localStorage.getItem("selected_facility_id"));
    const [selectedFacilityName, setSelectedFacilityName] = useState(localStorage.getItem("selected_facility_name"));
    const [selectedCityName, setSelectedCityName] = useState(localStorage.getItem("selected_city_name"));

    // ================================================================


    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
            </>
            <div className='facility_container'>
                <AlertPopUp alertShow={alertShow} alertType={alertType} alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
                <div className='d-flex justify-content-between align-items-center flex-wrap'>
                    <div className='d-flex align-items-center gap-3 mb-3'>
                        <h3 className="invoice-heading">Meter Master</h3>
                    </div>
                    <div className='d-flex align-items-center gap-3 mb-3'>
                        <button className='invoice_btn' style={{ color: "white" }} onClick={handleAddNewMeterShow}>
                            <span className='generate_invoice'><img src='./images/icons/AddIcon.svg' style={{ marginRight: "10px" }} alt="+" />Add New Meter</span>
                            <span className='generate'><img src={'./images/icons/AddIcon.svg'} style={{ marginRight: "10px" }} alt="+" />Add</span></button>
                    </div>
                </div>
                {/* <div className='d-flex align-items-center gap-3 mb-3 flex-wrap justify-content-start' style={{ flexDirection: "row" }}> */}
                <div className='fm-invoice-con-filters mb-3 mt-2' style={{ zIndex: 100 }}>
                    <div style={{ width: '250px' }} className="meter-report-filters fin_man_billing_period">
                        <p style={{ marginBottom: '-15px' }}>Facility:&nbsp;</p>
                        <SearchableDropdown
                            style={{ zIndex: 100 }}
                            // className = "searchable-dropdown2"
                            options={facilityList ? facilityList : []} //facilityList is the array of facilities
                            selectedOption={selectedFacility}
                            noOptionsAvailable="Facility unavailable"
                            onChange={(e) => {
                                setSelectedFacility(e.value)
                                const selectedFacility = facilitiesListForNav?.find((facility) => `${facility.city}, ${facility.name}` === e.value);
                                setSelectedFacilityName(selectedFacility?.name);
                                setSelectedCityName(selectedFacility?.city);
                                setSelectedFacility(`${selectedFacility?.city}, ${selectedFacility?.name}`);
                                setSelectedFacilityId(selectedFacility?.facility_id);
                            }}

                            placeholder="Select Facility"
                            isDisabled={false}
                        />
                    </div>
                    <div className="meter-report-filters payments-select-container fin_man_billing_period" >

                        <p style={{ marginBottom: '5px' }}>Meter Type:&nbsp;</p>
                        <select className='form-select payments-select invoice-select-date'
                            onChange={(e) => {
                                onChangeMeter(e.target.value);
                                setSelectMeter(e.target.value);

                            }} value={selectMeter}>
                            <option value="all">All</option>
                            <option value="electricity">Electricty</option>
                            <option value="water">Water</option>
                        </select>
                    </div>
                    <div className="fin_man_billing_period">
                        <p style={{ marginBottom: '-0px' }}>
                            {meterType === 'assigned' ? 'Assigned Date:' : 'Unassigned Date:'}&nbsp;&nbsp;&nbsp;
                        </p>
                        <div className="meter-report-filters fac-man-date-picker-container">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label=""
                                    className='form-control responsive-add-facility-input-fields'
                                    value={dayjs(selectedDate)}
                                    onChange={(e) => { handleDateChange(e) }}
                                    views={['day', 'month', 'year']}
                                    // minDate={dayjs(new Date())} // Set minimum selectable date
                                    maxDate={dayjs(new Date())} // Set maximum selectable date
                                    format={localStorage.getItem("date_format")}
                                    sx={{
                                        '.MuiInputBase-root': {
                                            height: '35px', // Adjust height
                                            backgroundColor: 'white', // Set background to white
                                            borderRadius: '6px', // Optional: Rounded corners
                                            fontSize: '16px', // Optional: Adjust text size
                                        },
                                    }}
                                // slotProps={{
                                //     textField: {
                                //         InputProps: {
                                //             readOnly: true, // Prevent typing in the input field
                                //         },
                                //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                //     },
                                // }}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                    <div className="fin_man_billing_period">
                        {/* <p style={{ marginBottom: '-10px' }}>&nbsp;</p> */}
                        <div className='fin_man_meter_search_bar_container'>
                            <input style={{ marginTop: '20px', height: '2.5rem' }} type='search' placeholder='Search' value={searchText}
                                onChange={(e) => handleSearchSubmit(e.target.value)}
                                className='fin_man_meter_search_bar' />
                            <GoSearch
                                style={{ marginTop: '17px' }} className='fin_man_meter_search_bar_icon C-pointer' />
                        </div>

                    </div>

                    <div className='d-flex align-items-center gap-2'>
                        <button className="add_fac_apply_btn primary-button" style={{ marginTop: '4px', color: 'white', height: '20px !important' }} onClick={() => {
                            handleApply()
                        }}>Apply</button>
                        <button className="add_fac_clear_btn secondary-button" style={{ marginTop: '4px', color: 'white', height: '20px !important' }}
                            onClick={() => {
                                handleClear()
                            }}
                        >Clear</button>

                    </div>

                </div>
                {/* </div> */}
                <Stack direction="horizontal" className="mt-1 invoice-type-div" gap={6}>
                    <div className="invoice-type-card" onClick={() => onChangeMeterType('assigned')}>
                        <p className={meterType === 'assigned' ? "selected-invoice-type C-pointer" : "C-pointer"}>Assigned Meters</p>
                    </div>
                    <div className="invoice-type-card" onClick={() => onChangeMeterType('unassigned')}>
                        <p className={meterType === 'unassigned' ? "selected-invoice-type C-pointer" : "C-pointer"}>Unassigned Meters</p>
                    </div>
                </Stack>

                <div className='table_container_facility_manager'>
                    <table>
                        <thead>
                            <tr className='fin_man_table_head commercial-head-table text-center'>
                                {meterType === 'assigned' ? (
                                    <>
                                        <th className='C-pointer' onClick={() => sortAssignedName()}>Assigned Name<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' onClick={() => sortAssignedMeterNumber()}>Meter Number<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' onClick={() => sortCompanyName()}>Company Name<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' onClick={() => sortContractName()}>Contract Name<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer'>Meter Type</th>
                                        <th className='C-pointer' onClick={() => sortAssignedDate()}>Assigned Date<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' onClick={() => sortInitialReading()}>Initial Reading<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' onClick={() => sortCreatedAt()}>Created At<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' onClick={() => sortUpdatedAt()}>Last Updated At<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer'>Action</th>


                                    </>
                                ) : (
                                    <>
                                        <th className='C-pointer' onClick={() => sortUnassignedMeterNumber()}>Meter Number<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' >Meter Type</th>
                                        <th className='C-pointer' onClick={() => sortUnassignedDate()}>Unassigned Date<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' onClick={() => sortFinalReading()}>Final Reading<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' onClick={() => sortCreatedAt()}>Created At<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' onClick={() => sortUpdatedAt()}>Last Updated At<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer' onClick={() => sortStatus()}>Status<FaSort className="icon-sort" alt="edit-icon" /></th>
                                        <th className='C-pointer'>Action</th>

                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody className='fac_man_table_body'>
                            {meterType === 'assigned' ? (
                                filteredMeters && filteredMeters.length > 0 ? (
                                    filteredMeters.map((each, index) => (
                                        <>
                                            {
                                                each.meter_type === 'electricity' ?
                                                    <>
                                                        <tr key={index} className={`table_row ${index % 2 === 0 ? 'even-row' : 'odd-row'}`}>
                                                            <td className='table_text_left'>{each.assigned_name}</td>
                                                            <td className='table_text_left'>{each.meter_number}</td>
                                                            <td className='table_text_left'>{each.company_name}</td>
                                                            <td className='table_text_left'>{each.contract_name}</td>
                                                            <td className='table_text_left'>{each.meter_type[0].toUpperCase() + each.meter_type.slice(1)}</td>
                                                            <td className='table_text_right'>{formatDateBasedOnValue(formatDateView(each.assigned_date))}</td>
                                                            <td className='table_text_right'>{formatToIndianRupee(each?.initial_reading ? each?.initial_reading : 0)} {each.meter_type === 'electricity' ? 'kWh' : 'kL'}</td>
                                                            <td className='table_text_right'>{timeElapsed(each.created_at)}</td>
                                                            <td className='table_text_right'>{timeElapsed(each.updated_at)}</td>
                                                            <td className='table_text_center'
                                                                onClick={() => handleAddNewMeterShowEdit(each)}
                                                                style={{ cursor: "pointer", justifyContent: "center", display: "flex" }}>
                                                                <img src="./images/icons/ViewViewIconEye.svg" alt="view-icon" />
                                                            </td>
                                                        </tr>
                                                    </>
                                                    :
                                                    <tr key={index} className={`table_row ${index % 2 === 0 ? 'even-row' : 'odd-row'}`}>
                                                        <td className='table_text_left'>{each.assigned_name}</td>
                                                        <td className='table_text_left'>{each.meter_number}</td>
                                                        <td className='table_text_left'>{each.company_name}</td>
                                                        <td className='table_text_left'>{each.contract_name}</td>
                                                        <td className='table_text_left'>{each.meter_type[0].toUpperCase() + each.meter_type.slice(1)}</td>
                                                        <td className='table_text_right'>{formatDateBasedOnValue(formatDateView(each.assigned_date))}</td>
                                                        <td className='table_text_right'>{formatToIndianRupee(each?.initial_reading ? each?.initial_reading : 0)} {each.meter_type === 'electricity' ? ' kWh' : ' kL'}</td>
                                                        <td className='table_text_right'>{timeElapsed(each.created_at)}</td>
                                                        <td className='table_text_right'>{timeElapsed(each.updated_at)}</td>
                                                        <td className='table_text_center'

                                                            onClick={() => handleAddNewMeterShowEdit(each)}
                                                            style={{ cursor: "pointer", justifyContent: "center", display: "flex" }}>

                                                            <img src="./images/icons/ViewViewIconEye.svg" alt="view-icon" />

                                                        </td>

                                                    </tr>

                                            }
                                        </>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan='10' style={{ textAlign: "center" }}>No Assigned meters available</td>
                                    </tr>
                                )
                            ) : (
                                filteredMeters && filteredMeters?.length > 0 ? (
                                    filteredMeters.map((each, index) => (
                                        <tr key={index} className={`table_row ${index % 2 === 0 ? 'even-row' : 'odd-row'}`}>
                                            <td className='table_text_left'>{each.meter_number}</td>
                                            <td className='table_text_left'>{each.meter_type[0].toUpperCase() + each.meter_type.slice(1)}</td>
                                            <td className='table_text_right'>{formatDateBasedOnValue(formatDateView(each.unassigned_date))}</td>
                                            <td className='table_text_right'>{formatToIndianRupee(each?.initial_reading ? each?.initial_reading : 0)} {each.meter_type === 'electricity' ? 'kWh' : 'kL'}</td>
                                            <td className='table_text_right'>{timeElapsed(each.created_at)}</td>
                                            <td className='table_text_right'>{timeElapsed(each.updated_at)}</td>
                                            <td className='table_text_left'>{each.is_working ? "Active" : "In-Active"}</td>
                                            <td className='table_text_center'
                                                // onClick={() => handleShowModal(facility.facility_id)} 
                                                onClick={() => handleAddNewMeterShowEdit(each)}
                                                style={{ cursor: "pointer", justifyContent: "center", display: "flex" }}>
                                                {/* <div> */}
                                                <img src="./images/icons/ViewViewIconEye.svg" alt="view-icon" />
                                                {/* </div> */}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan='10' style={{ textAlign: "center" }}>No Unassigned meters available</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
                <Pagination
                    handledPaginationNextClicked={handledPaginationNextClicked}
                    handledPaginationPrevClicked={handledPaginationPrevClicked}
                    isApplyClicked
                    totalRecords={meterType === "assigned" ? totalRecordsAssigned : totalRecordsUnassigned}
                    recordsPerPage={RECORDS_PER_PAGE_METER_MASTER}
                    currentPaginationPage={meterType === "assigned" ? currentPaginationPageAssigned : currentPaginationPageUnassigned}
                />
                <Modal keyboard={false} backdrop="static" show={showAddNewMeterPopUP} centered onHide={handleAddNewMeterClose} size='lg'>
                    <Modal.Header >
                        <Modal.Title>{selectedMeterToEdit ? 'Meter Details' : 'Add New Meter'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='meter-master-modal-popup d-flex flex-column gap-3'>
                            <div className='meter-master-modal gap-3'>
                                <div className='meter-master-input-container ' >
                                    <label className='fin_man_meter_modal_label'>Location:<span className='text-danger'>*</span></label>
                                    <div className='fin_man_meter_input_fields'>
                                        <input type='text'
                                            className='form-control responsive-add-facility-input-fields'
                                            value={localStorage.getItem("selected_city_name")}
                                            style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <div className='meter-master-input-container' >
                                    <label className='fin_man_meter_modal_label'>Facility:<span className='text-danger'>*</span></label>
                                    <div className='fin_man_meter_input_fields'>
                                        <input type='text'
                                            className='form-control responsive-add-facility-input-fields'
                                            value={localStorage.getItem("selected_facility_name")}
                                            style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='meter-master-modal gap-3'>
                                <div className='meter-master-input-container'>
                                    <label className='fin_man_meter_modal_label'>Meter Type:<span style={{ color: 'red' }}>*</span></label>
                                    <select className='form-select responsive-add-facility-input-fields invoice-select-date'
                                        value={modalMeterType} onChange={modelMeterTypeSelect}
                                        disabled={selectedMeterToEdit ? true : false}
                                    >
                                        <option value='electricity'>Electricity</option>
                                        <option value='water'>Water</option>
                                    </select>
                                </div>
                                <div className='meter-master-input-container' >
                                    <label className='fin_man_meter_modal_label'>Meter Number:<span style={{ color: 'red' }}>*</span></label>
                                    <div className='fin_man_meter_input_fields'>
                                        <input type='text'
                                            className={`form-control responsive-add-facility-input-fields add-facility-input-fields ${meterNumberError ? 'is-invalid' : ''}`}
                                            value={modelMeterNumber}
                                            onChange={handleModalMeterNumber}
                                            style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }}
                                            required
                                            disabled={selectedMeterToEdit ? true : false}
                                        />
                                        {meterNumberError && <div className="invalid-input">Only a-z,A-Z,0-9,-,_,/ are allowed.</div>}
                                        {uniqueMeterNumberError && <div className="invalid-input">Meter number should be unique!</div>}
                                        {lenghtError && <div className="invalid-input">Must be between 3 to 200 characters</div>}
                                    </div>
                                </div>
                            </div>
                            {modalMeterType === 'electricity' &&
                                <>
                                    <div className='meter-master-modal gap-3'>
                                        <div className='meter-master-input-container'>
                                            <label className='fin_man_meter_modal_label'>Intial EB reading:<span style={{ color: 'red' }}>*</span></label>
                                            <div className='fin_man_meter_input_fields'>
                                                <input type='text'
                                                    className='form-control responsive-add-facility-input-fields'
                                                    value={intialEBReading} onChange={handleIntialEBReading}
                                                    onKeyDown={handleKeyDownForMeterReadings}
                                                    style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }}
                                                    disabled={(selectedMeterToEdit)}

                                                />
                                            </div>
                                        </div>
                                        <div className='meter-master-input-container' >
                                            <label className='fin_man_meter_modal_label'>Units:<span style={{ color: 'red' }}>*</span></label>
                                            <div className='fin_man_meter_input_fields'>
                                                <input type='text' className='form-control responsive-add-facility-input-fields' value={"kWh"} onChange={handleIntialDGReading} style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }} disabled={true} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='meter-master-modal gap-3'>
                                        <div className='meter-master-input-container'>
                                            <label className='fin_man_meter_modal_label'>Intial DG reading:<span style={{ color: 'red' }}>*</span></label>
                                            <div className='fin_man_meter_input_fields'>
                                                <input type='text'
                                                    className='form-control responsive-add-facility-input-fields'
                                                    value={intialDGReading} onChange={handleIntialDGReading} onKeyDown={handleKeyDownForMeterReadings}
                                                    style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }}
                                                    disabled={(selectedMeterToEdit)}
                                                />
                                            </div>
                                        </div>
                                        <div className='meter-master-input-container' >
                                            <label className='fin_man_meter_modal_label'>Units:<span style={{ color: 'red' }}>*</span></label>
                                            <div className='fin_man_meter_input_fields'>
                                                <input type='text' className='form-control responsive-add-facility-input-fields' value={"kWh"} style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }} disabled={true} />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            {modalMeterType === 'water' &&
                                <div className='meter-master-modal gap-3'>
                                    <div className='meter-master-input-container'>
                                        <label className='fin_man_meter_modal_label'>Initial reading:<span style={{ color: 'red' }}>*</span></label>
                                        <div className='fin_man_meter_input_fields'>
                                            <input type='text'
                                                className='form-control responsive-add-facility-input-fields'
                                                value={intialReading} onChange={handleIntialReading} onKeyDown={handleKeyDownForMeterReadings}
                                                style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }}
                                                disabled={(selectedMeterToEdit)}
                                            />
                                        </div>
                                    </div>
                                    <div className='meter-master-input-container' >
                                        <label className='fin_man_meter_modal_label'>Units:<span style={{ color: 'red' }}>*</span></label>
                                        <div className='fin_man_meter_input_fields'>
                                            <input type='text' className='form-control responsive-add-facility-input-fields' value={"kL"} style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }} disabled={true} />
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                selectedMeterToEdit && !(selectedMeterToEdit.contract_id) &&
                                <div className='meter-master-modal gap-3'>
                                    <div className='meter-master-input-container'>
                                        <label className='fin_man_meter_modal_label'>Status<span style={{ color: 'red' }}>*</span></label>
                                        <div className='fin_man_meter_input_fields'>
                                            <select className='form-select responsive-add-facility-input-fields invoice-select-date' value={editedMeterStatus}
                                                onChange={(e) => setEditedMeterStatus(e.target.value)}
                                                disabled={(selectedMeterToEdit && !isEditClicked)}
                                            >
                                                <option value='1'>Active</option>
                                                <option value='0'>In-Active</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            }

                            {selectedMeterToEdit?.contract_id && <>
                                <div className='meter-master-modal gap-3'>
                                    <div className='meter-master-input-container'>
                                        <label className='fin_man_meter_modal_label'>Contract<span style={{ color: 'red' }}>*</span></label>
                                        <div className='fin_man_meter_input_fields'>
                                            <select className='form-select responsive-add-facility-input-fields invoice-select-date'
                                                value={selectedMeterToEdit?.contract_name}
                                                onChange={handleContractSelect}
                                                disabled={(true)}
                                            >
                                                <option value=''>{selectedMeterToEdit?.contract_name}</option>

                                            </select>
                                        </div>
                                    </div>
                                    <div className='meter-master-input-container' >
                                        <label className='fin_man_meter_modal_label'>Meter Name:<span style={{ color: 'red' }}>*</span></label>
                                        <div className='fin_man_meter_input_fields'>
                                            <input type='text' className='form-control responsive-add-facility-input-fields' value={selectedMeterToEdit?.assigned_name} onChange={(e) => {
                                                setMeterName(e.target.value)
                                            }} style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>}

                            <hr style={{ marginTop: '0px', marginBottom: '0px' }} />

                            {!selectedMeterToEdit?.contract_id && selectedMeterToEdit && (editedMeterStatus === 1) ?
                                <>
                                    <div className='d-flex gap-3 '>
                                        <div className='d-flex align-items-center justify-content-between' style={{ width: "49%" }}>
                                            <h5 className='fin_man_meter_modal_label'>Assign To A Contract</h5>
                                        </div>
                                    </div>



                                    <div className='d-flex justify-content-between gap-3'>
                                        <div className='d-flex align-items-center justify-content-between' style={{ width: "50%" }}>
                                            <label className='fin_man_meter_modal_label'>Contract<span style={{ color: 'red' }}>*</span></label>
                                            <div className='fin_man_meter_input_fields'>
                                                <select className='fin_man_model_meter_dropdown'
                                                    value={selectedContract}
                                                    onChange={handleContractSelect}
                                                //  disabled={(selectedMeterToEdit && !isEditClicked)}
                                                >
                                                    <option value=''>Select Contract</option>
                                                    {contractsWithSpecificService && contractsWithSpecificService.map((each, index) => {
                                                        return (
                                                            <option key={index} value={each.contract_id}>{each.contract_name}</option>
                                                        )
                                                    }
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center' style={{ width: "50%" }}>
                                            <label className='fin_man_meter_modal_label'>Meter Name:<span style={{ color: 'red' }}>*</span></label>
                                            <div className='fin_man_meter_input_fields'>
                                                <input type='text' className='form-control add-facility-input-fields' value={meterName} onChange={(e) => {
                                                    setMeterName(e.target.value)
                                                }} style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }} />
                                            </div>
                                        </div>
                                    </div>
                                </>
                                :
                                null
                            }

                            {selectedMeterToEdit?.contract_id &&
                                <>
                                    {modalMeterType === 'electricity' &&
                                        <>
                                            <div className='d-flex justify-content-between gap-3'>
                                                <div className='d-flex align-items-center justify-content-between' style={{ width: "50%" }}>
                                                    <label className='fin_man_meter_modal_label'>Final EB reading:<span style={{ color: 'red' }}>*</span></label>
                                                    <div className='fin_man_meter_input_fields'>
                                                        <input type='text'
                                                            className='form-control add-facility-input-fields'
                                                            value={finalMeterReading} onChange={(e) => {
                                                                const input = e.target.value;
                                                                const formattedInput = formatNumericInput(input, 3);
                                                                setFinalMeterReading(formattedInput)
                                                            }}
                                                            onKeyDown={handleKeyDownForMeterReadings}
                                                            style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }}
                                                        // disabled={(selectedMeterToEdit && !isEditClicked)}

                                                        />
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between align-items-center' style={{ width: "50%" }}>
                                                    <label className='fin_man_meter_modal_label'>Units:<span style={{ color: 'red' }}>*</span></label>
                                                    <div className='fin_man_meter_input_fields'>
                                                        <input type='text' className='form-control add-facility-input-fields' value={"kWh"} onChange={handleIntialDGReading} style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }} disabled={true} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex justify-content-between gap-3'>
                                                <div className='d-flex align-items-center justify-content-between' style={{ width: "50%" }}>
                                                    <label className='fin_man_meter_modal_label'>Final DG reading:<span style={{ color: 'red' }}>*</span></label>
                                                    <div className='fin_man_meter_input_fields'>
                                                        <input type='text'
                                                            className='form-control add-facility-input-fields'
                                                            value={finalDgMeterReadings} onChange={e => {
                                                                const input = e.target.value;
                                                                const formattedInput = formatNumericInput(input, 3);
                                                                setFinalDgMeterReadings(formattedInput)
                                                            }} onKeyDown={handleKeyDownForMeterReadings}
                                                            style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }}
                                                        // disabled={(selectedMeterToEdit && !isEditClicked)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between align-items-center' style={{ width: "50%" }}>
                                                    <label className='fin_man_meter_modal_label'>Units:<span style={{ color: 'red' }}>*</span></label>
                                                    <div className='fin_man_meter_input_fields'>
                                                        <input type='text' className='form-control add-facility-input-fields' value={"kWh"} style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }} disabled={true} />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {modalMeterType === 'water' &&
                                        <div className='d-flex justify-content-between gap-3'>
                                            <div className='d-flex align-items-center justify-content-between' style={{ width: "50%" }}>
                                                <label className='fin_man_meter_modal_label'>Final reading:<span style={{ color: 'red' }}>*</span></label>
                                                <div className='fin_man_meter_input_fields'>
                                                    <input type='text'
                                                        className='form-control add-facility-input-fields'
                                                        value={finalMeterReading} onChange={e => {
                                                            const input = e.target.value;
                                                            const formattedInput = formatNumericInput(input, 3);
                                                            setFinalMeterReading(formattedInput)
                                                        }} onKeyDown={handleKeyDownForMeterReadings}
                                                        style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }}
                                                    // disabled={(selectedMeterToEdit && !isEditClicked)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='d-flex justify-content-between align-items-center' style={{ width: "50%" }}>
                                                <label className='fin_man_meter_modal_label'>Units:<span style={{ color: 'red' }}>*</span></label>
                                                <div className='fin_man_meter_input_fields'>
                                                    <input type='text' className='form-control add-facility-input-fields' value={"kL"} style={{ paddingLeft: "14px", border: "0.5px solid #9D9D9C" }} disabled={true} />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </>

                            }


                            <>
                                <div className='d-flex justify-content-between gap-3'>

                                    {selectedMeterToEdit?.contract_id ? <div className='d-flex justify-content-between align-items-center' style={{ width: "49%" }}>
                                        <button
                                            className='btn btn-secondary'
                                            onClick={() => setShowUnassignConfirm(true)}
                                        >
                                            Unassign Meter
                                        </button>
                                    </div> :
                                        <>
                                            {
                                                selectedMeterToEdit && (editedMeterStatus === 1) ?
                                                    <div className='d-flex justify-content-between align-items-center' style={{ width: "49%" }}>
                                                        <button className='btn btn-secondary' onClick={() => {
                                                            confirmAssignContract()
                                                        }}>Assign Meter</button>
                                                    </div>
                                                    :
                                                    null

                                            }

                                        </>

                                    }
                                </div>
                            </>



                            {/* {

                                <div className='d-flex gap-3 '>
                                    <div className='d-flex align-items-center justify-content-between' style={{ width: "49%" }}>
                                        <label className='fin_man_meter_modal_label'>Contract<span style={{ color: 'red' }}>*</span></label>
                                        <div className='fin_man_meter_input_fields'>
                                            <select className='fin_man_model_meter_dropdown' value={editedMeterStatus}
                                                onChange={(e) => setEditedMeterStatus(e.target.value)}
                                                disabled={(selectedMeterToEdit && !isEditClicked)}
                                            >
                                                <option value='1'>Active</option>
                                                <option value='0'>In-Active</option>
                                            </select>
                                        </div>

                                    </div>
                                    <div>
                                        <button className='btn btn-secondary' onClick={() => {
                                            // handleAssignContract(selectedMeterToEdit)
                                        }}>Unassign</button>
                                    </div>
                                </div>
                            } */}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {
                            selectedMeterToEdit ?
                                <>
                                    <Button className='btn btn-primary px-5 secondary-button' onClick={() => setShowCloseConfirmationModal(true)}>
                                        Cancel
                                    </Button>
                                    {
                                        isEditClicked ?
                                            <Button className='btn btn-primary px-4 primary-button'
                                                // onClick={handleNewMetersave}  
                                                onClick={handleUpdateMeter}
                                            >
                                                Update
                                            </Button>
                                            :
                                            <Button className='btn btn-primary px-4 primary-button'
                                                // onClick={handleNewMetersave}  
                                                onClick={handleEditClick}
                                            >
                                                Edit
                                            </Button>
                                    }
                                </>
                                :
                                <>
                                    <Button className='btn btn-primary px-5 secondary-button' onClick={() => setShowCloseConfirmationModal(true)}>
                                        Cancel
                                    </Button>
                                    <Button className='btn btn-primary px-4 primary-button' onClick={confirmSaveNewMeter} style={{ border: "1px solid #878787" }} disabled={saveDisabled || modalMeterType === '' ||
                                        modelMeterNumber === "" || (intialEBReading === "" || intialDGReading === "") && intialReading === "" ||
                                        lenghtError || uniqueMeterNumberError}>
                                        Save Meter
                                    </Button>
                                </>

                        }

                    </Modal.Footer>
                </Modal>
                <Modal keyboard={false} backdrop="static" show={showCloseConfirmationModal} centered onHide={handleCloseConfirmation}>
                    <Modal.Body className="text-center">
                        <h5>Are you sure you want to Cancel? Your progress will not be saved.</h5>
                    </Modal.Body>
                    <Modal.Footer className="footer">
                        <Button variant="secondary" className="confirmation" onClick={handleCloseConfirmation}>
                            Cancel
                        </Button>
                        <Button variant="secondary" className="confirmation-left" onClick={handleProceed}>
                            Proceed
                        </Button>
                    </Modal.Footer>
                </Modal>

                <AlertPopUp
                    alertShow={showUnassignConfirm}
                    alertType="question"
                    alertMsg="Confirmation"
                    alertValue="Are you sure you want to unassign this meter?"
                    alertButtons={[
                        {
                            name: 'Cancel',
                            action: () => setShowUnassignConfirm(false),
                            variant: 'secondary'
                        },
                        {
                            name: 'Proceed',
                            action: () => {
                                setShowUnassignConfirm(false);
                                handleUnassignContract();
                            },
                            variant: 'primary'
                        }
                    ]}
                />

                <Modal keyboard={false} backdrop="static" show={meterSuccessPopUp} onHide={() => {
                    setMeterSuccessPopUp(false)
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <img src="./images/icons/popper.svg" alt="Party Popper" />
                        <h5>Success!</h5>
                        <p className="mb-3">{modalMeterType === 'electricity' ? 'An' : 'A'} <b>{modalMeterType}</b> meter with name <b>{modelMeterNumber}</b> has been added.</p>
                    </Modal.Body>
                    <Modal.Footer className="footer d-flex justify-content-center">
                        <Button variant="secondary" className="secondary" onClick={() => {
                            setMeterSuccessPopUp(false)
                            // window.location.reload()
                            setShowAddNewMeterPopUp(false)
                            setLengthError(false)
                            setMeterNumberError(false)
                            setUniqueMeterNumberError(false)
                            setModalMeterType('electricity')
                            setModalMeterNumber('')
                            setIntialDGReading('')
                            setIntialEBReading('')
                            setIntialReading('')
                            handleApply()
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                {loading && <Loader />}
                {contractApiLoader && <Loader />}
                <Modal keyboard={false} backdrop="static" show={meterErroePopUp} onHide={() => {
                    setMeterErrorPopUp(false)
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <MdErrorOutline style={{ fontWeight: "10px", fontSize: "60px", color: "#Cc0202", opacity: 0.8 }} />
                        <h5>Error!</h5>
                        <p className="mb-3">{addMeterError?.response?.data.message}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            setMeterErrorPopUp(false)
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            <Footer />
        </>
    );
};

export default MeterMaster;
